export enum GlobalConfig {
  SYS_API_VERSION = "/sys-v100001",
  OTHER_API_VERSION = "/other-v100001",
  HOUSE_API_VERSION = "/house-v100001",
  FINANCE_API_VERSION = "/finance-v100001",
  REPORT_API_VERSION = "/report-v100001",
}
